
/*
 * BUILD @athena/forge v9.0.0
 * THIS IS AN AUTOGENERATED FILE
 */

import React from 'react';
import IconBase from '../_IconBase';
const Flag = props => {
  const modClassName = props.className;

  return (
    <IconBase viewBox="0 0 25 25" {...props} className={ modClassName }>
      <g>
        <g className="fe_c_icon__background">
          <rect y="-0.2" width="25" height="25"></rect>
        </g>
        <g className="fe_c_icon__icon fe_c_icon__icon--primary">
          <path d="M17.3,8.6l3.2-6H7.8A3.4,3.4,0,0,0,4.4,5.9V22H5.9V14.5H20.5ZM5.9,5.9A1.9,1.9,0,0,1,7.8,4.1H18L15.6,8.6,18,13H5.9Z"></path>
        </g>
      </g>
    </IconBase>);
};

Flag.defaultProps = {
  title: 'Flag',
};

export default Flag;
